/**
 * Named `staleTime` values. They rename values the app already uses; none is a
 * recommendation. A domain migration swaps a spelling for a preset only when the
 * value is exactly equal, and keeps any other value as a named local constant.
 */
export const STALE_TIME = {
  none: 0,
  short: 30_000,
  minute: 60_000,
  /** The `QueryClient` default (`components/context/tanstack-provider.tsx`). */
  standard: 2 * 60_000,
  long: 5 * 60_000,
  forever: Infinity
} as const
